import Flux from 'lib/flux';

export default Flux.createConstants({
  messages: ['RESIZED'],
});
